import { render } from "./BackerCenterPaymentsPreview.vue?vue&type=template&id=bb633020"
import script from "./BackerCenterPaymentsPreview.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__